module.exports = __webpack_public_path__ + "di-logo.png?53fdf94b835a38ca489188933c950d02";